import { useEffect, type ReactNode } from "react";

interface SidePanelProps {
  open: boolean;
  title: string;
  subtitle?: string;
  onClose: () => void;
  children: ReactNode;
}

export default function SidePanel({ open, title, subtitle, onClose, children }: SidePanelProps) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (event: KeyboardEvent) => {
      if (event.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[70]">
      <button
        type="button"
        aria-label="Fechar"
        onClick={onClose}
        className="absolute inset-0 h-full w-full cursor-pointer bg-foreground-950/40 backdrop-blur-[2px]"
      />
      <aside className="ab-panel-in absolute right-0 top-0 flex h-full w-full max-w-md flex-col bg-background-50 shadow-none">
        <header className="flex items-start justify-between gap-4 border-b border-background-200 px-5 py-5 md:px-7">
          <div>
            <h3 className="font-heading text-2xl text-foreground-900">{title}</h3>
            {subtitle ? (
              <p className="mt-1 text-xs text-foreground-600 md:text-sm">{subtitle}</p>
            ) : null}
          </div>
          <button
            type="button"
            onClick={onClose}
            aria-label="Fechar painel"
            className="flex h-10 w-10 shrink-0 cursor-pointer items-center justify-center rounded-full border border-background-300 text-foreground-700 transition-colors hover:bg-background-100"
          >
            <i className="ri-close-line text-xl" />
          </button>
        </header>
        <div className="flex-1 overflow-y-auto px-5 py-6 md:px-7">{children}</div>
      </aside>
    </div>
  );
}